<template>
  <div>
    <SetupSteps v-if="!setupComplete" />
    <FormCard
      v-model="voucherTemplate"
      :create-button-text="submitButtonText"
      @formSubmit="$emit('formSubmit', $event)">
      <CardForm
        :resource="voucherTemplate"
        section-title="Merchant Details"
        resource-name="voucher_template">
        <div class="invoice-preferences invoice-preferences-wrap-md">
          <div class="invoice-preferences-header d-none d-lg-block">
            <div class="invoice-preferences-header-wrapper">
              <div class="invoice-preferences-header-wrapper-item col-lg-6">
                ELEMENT
              </div>
              <div class="invoice-preferences-header-wrapper-item col-lg-8">
                DISPLAY
              </div>
              <div class="invoice-preferences-header-wrapper-item col-lg-6">
                HIDE/SHOW
              </div>
              <div class="col-lg-4" />
            </div>
            <CardDivider />
          </div>
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-lg-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Logo
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-lg-8 col-24">
              <ImageUpload
                v-if="editFields.logo"
                v-model="voucherTemplate.logo"
                :display-label="false"
                name="voucher_template[logo]" />
              <img v-else :src="voucherTemplate.logo.url" class="invoice-preferences-row-cell-image">
            </div>
            <div class="invoice-preferences-row-cell col-lg-6 col-24">
              <ToggleButton
                v-model="voucherTemplate.display_invoice_logo"
                name="voucher_template[display_invoice_logo]"
                true-icon="icon-eye"
                false-icon="icon-eye-slash"
                :default-checked="true" />
            </div>
            <div class="invoice-preferences-row-cell col-lg-4 col-24">
              <router-link v-if="!merchant.logo.url"
                           :to="`/merchant/${merchant.id}/profile#company-logo`"
                           class="btn btn-info ihjoz-button">
                Add
              </router-link>
              <a v-else-if="editFields.logo"
                 href="#"
                 class="btn btn-info ihjoz-button"
                 @click.prevent="toggleEdit('logo', ['logo'])">
                Cancel
              </a>
              <a v-else
                 href="#"
                 class="btn btn-info ihjoz-button"
                 @click.prevent="toggleEdit('logo')">
                Edit
              </a>
            </div>
          </div>
          <CardDivider />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-lg-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                {{ merchantLabel }}
              </h3>
            </div>
            <div v-if="merchant.legal_name" class="invoice-preferences-row-cell col-lg-8 col-24">
              {{ merchant.legal_name }}
            </div>
            <div v-else class="invoice-preferences-row-cell text-danger col-lg-8 col-24">
              Required!
            </div>
            <div class="invoice-preferences-row-cell col-lg-6 col-24 mt-0" />
            <div class="invoice-preferences-row-cell col-lg-4 col-24">
              <router-link :to="`/merchant/${merchant.id}/account#company-legal-name`"
                           class="btn btn-info ihjoz-button">
                {{ editOrAddText(merchant.legal_name) }}
              </router-link>
            </div>
          </div>
          <CardDivider />
          <div v-if="merchant.vat_number" class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-lg-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                VAT Number
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-lg-8 col-24">
              {{ merchant.vat_number }}
            </div>
            <div class="invoice-preferences-row-cell col-lg-6 col-24">
              <ToggleButton
                v-model="voucherTemplate.display_vat_number"
                name="voucher_template[display_vat_number]"
                true-icon="icon-eye"
                false-icon="icon-eye-slash"
                :default-checked="true" />
            </div>
            <div class="invoice-preferences-row-cell col-lg-4 col-24">
              <router-link :to="`/merchant/${merchant.id}/account#company-vat-number`"
                           class="btn btn-info ihjoz-button">
                {{ editOrAddText(merchant.vat_number) }}
              </router-link>
            </div>
          </div>
          <CardDivider v-if="merchant.vat_number" />
          <div v-if="merchant.mof_number" class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-lg-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                MOF Number
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-lg-8 col-24">
              {{ merchant.mof_number }}
            </div>
            <div class="invoice-preferences-row-cell col-lg-6 col-24">
              <ToggleButton
                v-model="voucherTemplate.display_mof_number"
                name="voucher_template[display_mof_number]"
                true-icon="icon-eye"
                false-icon="icon-eye-slash"
                :default-checked="true" />
            </div>
            <div class="invoice-preferences-row-cell col-lg-4 col-24">
              <router-link :to="`/merchant/${merchant.id}/account#company-mof-number`"
                           class="btn btn-info ihjoz-button">
                {{ editOrAddText(merchant.mof_number) }}
              </router-link>
            </div>
          </div>
          <CardDivider v-if="merchant.mof_number" />
          <div v-if="merchant.cr_number" class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-lg-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                CR Number
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-lg-8 col-24">
              {{ merchant.cr_number }}
            </div>
            <div class="invoice-preferences-row-cell col-lg-6 col-24">
              <ToggleButton
                v-model="voucherTemplate.display_cr_number"
                name="voucher_template[display_cr_number]"
                true-icon="icon-eye"
                false-icon="icon-eye-slash"
                :default-checked="true" />
            </div>
            <div class="invoice-preferences-row-cell col-lg-4 col-24">
              <router-link :to="`/merchant/${merchant.id}/account#company-cr-number`"
                           class="btn btn-info ihjoz-button">
                {{ editOrAddText(merchant.cr_number) }}
              </router-link>
            </div>
          </div>
          <CardDivider v-if="merchant.cr_number" />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-lg-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Phone Number
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-lg-8 col-24">
              <div class="form-group custom-form-group"
                   :class="{ 'd-none': !editFields.phone_number }">
                <vue-tel-input
                  ref="phoneInput"
                  v-model="voucherTemplate.phone_number"
                  input-id="phoneInput"
                  name="voucher_template[phone_number]"
                  :ignored-countries="['IL']"
                  :enabled-country-code="true"
                  :preferred-countries="['LB', 'SA']"
                  :valid-characters-only="true"
                  :default-country="'LB'"
                  :disabled-fetching-country="true"
                  mode="national"
                  wrapper-classes="ihjoz-tel-input mb-0"
                  input-classes="ihjoz-tel-input-field ihjoz-tel-input-field-code-visible"
                  @onInput="onInput"
                  @input="validateNumber" />
                <input
                  :value="selectedPhoneCountryCode"
                  name="voucher_template[phone_country_code]"
                  type="hidden">
              </div>
              <span :class="{ 'd-none': editFields.phone_number }">
                {{ voucherTemplate.phone_number }}
              </span>
            </div>
            <div class="invoice-preferences-row-cell col-lg-6 col-24 mt-0" />
            <div class="invoice-preferences-row-cell col-lg-4 col-24">
              <router-link v-if="!merchant.phone_number"
                           :to="`/merchant/${merchant.id}/profile#mobileInput`"
                           class="btn btn-info ihjoz-button">
                Add
              </router-link>
              <a v-else-if="editFields.phone_number"
                 href="#"
                 class="btn btn-info ihjoz-button"
                 @click.prevent="toggleEdit('phone_number', ['phone_number'])">
                Cancel
              </a>
              <a v-else
                 href="#"
                 class="btn btn-info ihjoz-button"
                 @click.prevent="toggleEdit('phone_number')">
                Edit
              </a>
            </div>
          </div>
          <CardDivider />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-lg-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Email
              </h3>
            </div>
            <div v-if="editFields.email" class="invoice-preferences-row-cell col-lg-8 col-24">
              <TextInput
                v-model="voucherTemplate.email"
                name="voucher_template[email]"
                :display-label="false" />
            </div>
            <div v-else class="invoice-preferences-row-cell col-lg-8 col-24">
              {{ voucherTemplate.email }}
              <HiddenInput
                v-model="voucherTemplate.email"
                name="voucher_template[email]" />
            </div>
            <div class="invoice-preferences-row-cell col-lg-6 col-24 mt-0" />
            <div class="invoice-preferences-row-cell col-lg-4 col-24">
              <router-link v-if="!merchant.email"
                           :to="`/merchant/${merchant.id}/profile#company-email`"
                           class="btn btn-info ihjoz-button">
                Add
              </router-link>
              <a v-else-if="editFields.email"
                 href="#"
                 class="btn btn-info ihjoz-button"
                 @click.prevent="toggleEdit('email')">
                Cancel
              </a>
              <a v-else
                 href="#"
                 class="btn btn-info ihjoz-button"
                 @click.prevent="toggleEdit('email', ['email'])">
                Edit
              </a>
            </div>
          </div>
          <CardDivider />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-lg-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Address
              </h3>
            </div>
            <div v-if="editFields.address" class="invoice-preferences-row-cell col-lg-8 col-24">
              <MultilineTextInput
                v-model="voucherTemplate.address"
                name="voucher_template[address]"
                label="City"
                class="mb-2" />
              <TextInput
                v-model="voucherTemplate.zip_code"
                name="voucher_template[zip_code]"
                class="mb-2" />
              <TextInput
                v-model="voucherTemplate.city"
                name="voucher_template[city]"
                class="mb-2" />
              <ItemSelect
                v-model="voucherTemplate.country_id"
                :items="countries"
                name="voucher_template[country_id]"
                label="Country" />
            </div>
            <div v-else class="invoice-preferences-row-cell col-lg-8 col-24">
              <div v-if="voucherTemplate.address">
                <template v-for="text in splitAddress">
                  <p>{{ text }}</p>
                </template>
                <p v-if="templateZipCityCountry" v-raw="templateZipCityCountry" />
              </div>
              <HiddenInput
                v-model="voucherTemplate.address"
                name="voucher_template[address]" />
              <HiddenInput
                v-model="voucherTemplate.city"
                name="voucher_template[city]" />
              <HiddenInput
                v-model="voucherTemplate.zip_code"
                name="voucher_template[zip_code]" />
              <HiddenInput
                v-model="voucherTemplate.country_id"
                name="voucher_template[country_id]" />
            </div>
            <div class="invoice-preferences-row-cell col-lg-6 col-24 mt-0" />
            <div class="invoice-preferences-row-cell col-lg-4 col-24">
              <router-link v-if="!hasMerchantAddress"
                           :to="`/merchant/${merchant.id}/profile#company-address`"
                           class="btn btn-info ihjoz-button">
                Add
              </router-link>
              <a v-else-if="editFields.address"
                 href="#"
                 class="btn btn-info ihjoz-button"
                 @click.prevent="toggleEdit('address', ['address', 'zip_code', 'city', 'country_id'])">
                Cancel
              </a>
              <a v-else
                 href="#"
                 class="btn btn-info ihjoz-button"
                 @click.prevent="toggleEdit('address')">
                Edit
              </a>
            </div>
          </div>
        </div>
      </CardForm>

      <CardForm
        :resource="voucherTemplate"
        section-title="Template Settings"
        resource-name="voucher_template">
        <input type="hidden" name="voucher_template[voucher_type]" value="Invoice">
        <TextInput
          v-model="voucherTemplate.name"
          name="voucher_template[name]"
          custom-label="Internal Name"
          disclaimer="Name used internally to distinguish between different templates of the same type. Internal Name is used in menus and reports and do not appear to the customer. (i.e. Invoice with VAT, Invoice without VAT, Invoice with absorbed fees …)" />
        <CardDivider />
        <TextInput
          v-model="voucherTemplate.document_title"
          name="voucher_template[document_title]"
          custom-label="Document Name"
          disclaimer="Document Name displayed to the customer (Invoice, Credit Note, Payment Request …)" />
        <CardDivider />
        <div class="invoice-preferences-row">
          <div class="invoice-preferences-row-label col-md-6 col-24">
            <h3 class="invoice-preferences-row-label-title">
              Voucher Type
            </h3>
          </div>
          <div class="invoice-preferences-row-cell col-md-18 col-24">
            <ItemSelect
              v-model="voucherTemplate.voucher_type"
              :items="voucher_types"
              name="voucher_template[voucher_type]"
              key-method="name"
              :shortened="false"
              :default-value="voucherTemplate.voucher_type"
              value-method="value"
              :display-label="false" />
          </div>
        </div>
      </CardForm>

      <CardForm
        :resource="voucherTemplate"
        section-title="Invoice Settings"
        resource-name="voucher_template">
        <div class="invoice-preferences invoice-preferences-wrap-sm">
          <div class="invoice-preferences-header d-none d-md-block">
            <div class="invoice-preferences-header-wrapper">
              <div class="invoice-preferences-header-wrapper-item col-md-6">
                ELEMENT
              </div>
              <div class="invoice-preferences-header-wrapper-item col-md-18">
                DISPLAY
              </div>
            </div>
            <CardDivider />
          </div>
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-md-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Default Currency
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-md-18 col-24">
              {{ voucherTemplate.merchant_base_currency.iso_code }} - {{ voucherTemplate.merchant_base_currency.sign }}
            </div>
          </div>
          <CardDivider />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-md-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Invoice Number
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-md-18 col-24">
              <RadioControlWrapper
                :wrappable="true">
                <BoolRadioControl
                  v-model="voucherTemplate.manual_numbering"
                  name="voucher_template[manual_numbering]"
                  label="Autogenerate"
                  :used-value="false" />
                <BoolRadioControl
                  v-model="voucherTemplate.manual_numbering"
                  name="voucher_template[manual_numbering]"
                  label="Manual Input"
                  default-checked
                  :used-value="true" />
              </RadioControlWrapper>
            </div>
            <div class="invoice-preferences-row-label col-md-6 col-24 mt-md-4 mt-3">
              <h3 class="invoice-preferences-row-label-title">
                Sequence Number
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-md-18 col-24 mt-md-4 mt-3">
              <select
                v-model="sequenceNumberId"
                class="custom-select custom-input custom-input-short">
                <option value="">
                  New
                </option>
                <option
                  v-for="number in sequenceNumbers"
                  :key="number.id"
                  :value="number.id">
                  {{ number.prefix }}
                </option>
              </select>
            </div>
            <div class="invoice-preferences-row-label col-md-6 col-24" />
            <div class="invoice-preferences-row-cell col-md-18 col-24 m-0">
              <div class="invoice-preferences-row-cell-manual-numbering-mode" :class="{ visible: manualNumbering, 'd-none': !manualNumbering}">
                <TextInput
                  v-model="voucherTemplate.invoice_number_prefix"
                  name="voucher_template[invoice_number_prefix]"
                  custom-label="Prefix" />
              </div>
              <div class="invoice-preferences-row-cell-auto-numbering-mode" :class="{ visible: !manualNumbering, 'd-none': manualNumbering}">
                <HiddenInput
                  v-model="sequenceNumber.id"
                  name="voucher_template[sequence_number_attributes][id]" />
                <TextInput
                  v-model="sequenceNumber.prefix"
                  custom-label="Prefix"
                  name="voucher_template[sequence_number_attributes][prefix]" />
                <TextInput
                  v-model="sequenceNumber.next_number"
                  custom-label="Next Number"
                  name="voucher_template[sequence_number_attributes][next_number]" />
              </div>
            </div>
          </div>
          <CardDivider />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-md-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Purchase Order Number
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-md-18 col-24">
              <RadioControlWrapper
                :wrappable="true">
                <BoolRadioControl
                  v-model="voucherTemplate.show_purchase_order_number"
                  name="voucher_template[show_purchase_order_number]"
                  label="Enable"
                  default-checked
                  :used-value="true" />
                <BoolRadioControl
                  v-model="voucherTemplate.show_purchase_order_number"
                  name="voucher_template[show_purchase_order_number]"
                  label="Disable"
                  :used-value="false" />
              </RadioControlWrapper>
            </div>
          </div>
          <CardDivider />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-md-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Editor Type
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-md-18 col-24">
              <ItemSelect
                v-model="voucherTemplate.display_line_items"
                :items="editorTypes"
                name="voucher_template[display_line_items]"
                key-method="name"
                :shortened="false"
                :default-value="voucherTemplate.display_line_items"
                value-method="value"
                :display-label="false" />
            </div>
          </div>
          <CardDivider />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-md-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Default Due Date
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-md-18 col-24">
              <ItemSelect
                v-model="voucherTemplate.default_due_date_option"
                :items="dueDateOptions"
                name="voucher_template[default_due_date_option]"
                key-method="name"
                value-method="value"
                :display-label="false" />
            </div>
          </div>
          <CardDivider />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-md-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Default Subject
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-md-18 col-24">
              <ToggleButton
                v-model="voucherTemplate.display_subject"
                name="voucher_template[display_subject]"
                class="mb-2"
                true-icon="icon-eye"
                false-icon="icon-eye-slash"
                :default-checked="true" />
              <TextInput
                v-model="voucherTemplate.default_subject"
                name="voucher_template[default_subject]"
                :display-label="false" />
            </div>
          </div>
          <CardDivider />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-md-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Default Description
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-md-18 col-24">
              <ToggleButton
                v-model="voucherTemplate.display_description"
                name="voucher_template[display_description]"
                class="mb-2"
                true-icon="icon-eye"
                false-icon="icon-eye-slash"
                :default-checked="true" />
              <editor v-model="voucherTemplate.default_invoice_description"
                      :init="initValue"
                      name="voucher_template[default_invoice_description]" />
            </div>
          </div>
          <CardDivider />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-md-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Show/Hide Attachments
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-md-18 col-24">
              <ToggleButton
                v-model="voucherTemplate.display_attachments"
                name="voucher_template[display_attachments]"
                true-icon="icon-eye"
                false-icon="icon-eye-slash"
                :default-checked="true" />
            </div>
          </div>
          <CardDivider />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-md-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Default Notes
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-md-18 col-24">
              <ToggleButton
                v-model="voucherTemplate.display_notes"
                name="voucher_template[display_notes]"
                class="mb-2"
                true-icon="icon-eye"
                false-icon="icon-eye-slash"
                :default-checked="false" />
              <editor v-model="voucherTemplate.default_invoice_notes"
                      :init="initValue"
                      name="voucher_template[default_invoice_notes]" />
            </div>
          </div>
          <CardDivider />
          <div class="invoice-preferences-row">
            <div class="invoice-preferences-row-label col-md-6 col-24">
              <h3 class="invoice-preferences-row-label-title">
                Default Terms and Conditions
              </h3>
            </div>
            <div class="invoice-preferences-row-cell col-md-18 col-24">
              <ToggleButton
                v-model="voucherTemplate.display_terms"
                name="voucher_template[display_terms]"
                class="mb-2"
                true-icon="icon-eye"
                false-icon="icon-eye-slash"
                :default-checked="false" />
              <editor v-model="voucherTemplate.default_invoice_terms_of_service"
                      :init="initValue"
                      name="voucher_template[default_invoice_terms_of_service]" />
            </div>
          </div>
        </div>
      </CardForm>

      <div v-if="false" class="flip-card card d-none">
        <div class="flip-card-header px-i" :class="{'flip-card-header-closed': !opened}">
          <div class="flip-card-header-title">
            <h2 v-raw="`Payment Settings`" class="flip-card-header-title-text font-weight-light" />
          </div>
          <a class="flip-card-toggle flip-card-toggle-borderless" data-toggle="collapse" href="#payment-settings" @click="flipOpened()">
            <i class="demo-icon" :class="chevronDirection" />
          </a>
        </div>
        <div id="payment-settings" class="flip-card-body collapse" :class="{ show: true }">
          <div class="payment-settings">
            <div class="payment-settings-row">
              <div class="payment-settings-row-wrapper">
                <div class="payment-settings-row-wrapper-label col-24 col-lg-8 px-i">
                  <h3 class="payment-settings-row-wrapper-label-title">
                    {{ selectedInvoiceFee.name }}
                  </h3>
                </div>
                <div class="payment-settings-row-wrapper-center col-24 col-lg-10 px-i">
                  <div v-raw="displayFees(selectedInvoiceFee.fee_map_display.en)" class="payment-settings-row-wrapper-center-text" />
                </div>
                <div class="payment-settings-row-wrapper-end col-24 col-lg-6 px-i">
                  <RadioControlWrapper
                    :wrappable="true">
                    <BoolRadioControl
                      v-model="voucherTemplate.absorb_fee_default"
                      name="voucher_template[absorb_fee_default]"
                      label="Absorb Fee"
                      default-checked
                      :used-value="true" />
                    <BoolRadioControl
                      :v-model="voucherTemplate.absorb_fee_default"
                      name="voucher_template[absorb_fee_default]"
                      label="Pass on fee"
                      :used-value="false" />
                  </RadioControlWrapper>
                </div>
              </div>
            </div>
            <div v-for="(payment_setting, index) in voucherTemplate.payment_settings" :key="payment_setting.id" class="payment-settings-row">
              <div class="payment-settings-row-wrapper">
                <HiddenInput
                  v-model="payment_setting.id"
                  :name="`voucher_template[invoice_payment_settings_attributes][${index}][id]`" />
                <HiddenInput
                  v-model="payment_setting.payment_method.id"
                  :name="`voucher_template[invoice_payment_settings_attributes][${index}][payment_method_id]`" />
                <div class="payment-settings-row-wrapper-label col-24 col-lg-8 px-i">
                  <h3 class="payment-settings-row-wrapper-label-title">
                    {{ payment_setting.payment_method.name }}
                  </h3>
                  <div class="payment-settings-row-wrapper-label-images d-lg-flex" />
                </div>
                <div class="payment-settings-row-wrapper-center col-24 col-lg-10 px-i">
                  <div v-if="payment_setting.payment_method.fee_map_display" v-raw="displayFees(payment_setting.payment_method.fee_map_display)" class="payment-settings-row-wrapper-center-text" />
                  <div class="payment-settings-row-wrapper-center-button">
                    <ToggleButton
                      :v-model="payment_setting.enabled"
                      :name="`voucher_template[invoice_payment_settings_attributes][${index}][enabled]`"
                      :default-checked="true" />
                  </div>
                </div>
                <div class="payment-settings-row-wrapper-end col-24 col-lg-6 px-i">
                  <RadioControlWrapper
                    :wrappable="true">
                    <BoolRadioControl
                      :v-model="payment_setting.absorb_payment_fee"
                      :name="`voucher_template[invoice_payment_settings_attributes[${index}][absorb_payment_fee]]`"
                      label="Absorb Fee"
                      :value="payment_setting.absorb_payment_fee"
                      :checked="payment_setting.absorb_payment_fee"
                      :used-value="true" />
                    <BoolRadioControl
                      :v-model="payment_setting.absorb_payment_fee"
                      :name="`voucher_template[invoice_payment_settings_attributes[${index}][absorb_payment_fee]]`"
                      label="Pass on fee"
                      :value="payment_setting.absorb_payment_fee"
                      :checked="payment_setting.absorb_payment_fee"
                      :used-value="false" />
                  </RadioControlWrapper>
                </div>
              </div>
              <div class="payment-settings-row-mobile-images px-i d-lg-none">
                <div v-for="paymentBadge in paymentMethod.payment_method_badges" :key="paymentBadge.id" class="payment-method-badge-vertical">
                  <img v-if="paymentBadge.image.url" class="payment-method-badge-image" :src="paymentBadge.image.url">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FormCard>
  </div>
</template>

<script>
import SetupSteps from "@shared/components/Setup/SetupSteps.vue";
import FormCard from "@shared/components/UI/FormCard.vue";
import CardForm from "@shared/components/UI/CardForm.vue";
import CardDivider from "@shared/components/UI/CardDivider.vue";
import ToggleButton from "@shared/components/UI/ToggleButton.vue";
import BoolRadioControl from "@shared/components/UI/BoolRadioControl.vue";
import TextInput from "@shared/components/UI/TextInput.vue";
import MultilineTextInput from "@shared/components/UI/MultilineTextInput.vue";
import RadioControlWrapper from "@shared/components/UI/RadioControlWrapper.vue";
import ItemSelect from "@shared/components/UI/ItemSelect.vue";
import ImageUpload from "@shared/components/UI/ImageUpload.vue";
import PaymentMethodStore from "../../../tenant_admin/stores/PaymentMethodStore";
import TenantStore from "../../../tenant_admin/stores/TenantStore";
import Editor from "@tinymce/tinymce-vue";
import { VueTelInput } from "vue-tel-input";

export default {
  name: "VoucherTemplateForm",

  components: {
    SetupSteps,
    FormCard,
    CardForm,
    CardDivider,
    ToggleButton,
    BoolRadioControl,
    TextInput,
    MultilineTextInput,
    RadioControlWrapper,
    ItemSelect,
    ImageUpload,
    Editor,
    VueTelInput
  },

  props: {
    voucherTemplate: { type: Object },
    setupComplete: { type: Boolean },
    merchant: { type: Object },
    currencyTenants: { type: Array, default: () => [] },
    sequenceNumbers: { type: Array },
    countries: { type: Array }
  },

  data () {
    return {
      opened: true,
      paymentMethods: [],
      selectedInvoiceFee: {},
      sequenceNumberId: "",
      voucher_types: Dashboard.templateTypes,
      initValue: {
        theme: "silver",
        skin: false,
        language: this.$i18n.locale,
        branding: false,
        images_upload_url: "/api/v4/upload_image",
        paste_data_images: true,
        relative_urls: false,
        content_css: Dashboard.stylesheetPath,
        toolbar: "insertfile undo redo | styleselect fontselect fontsizeselect | bold italic underline strikethrough | ltr rtl alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link anchor image media | preview code fullscreen | forecolor backcolor removeformat| pagebreak | charmap table |",
        toolbar_drawer: "sliding",
        plugins: ["lists", "advlist", "paste", "link", "autoresize", "image", "imagetools", "preview", "code", "table", "pagebreak", "charmap", "directionality", "anchor", "media"],
        image_advtab: true,
        imagetools_cors_hosts: ["images-qa-ihjoz-com.s3.amazonaws.com", "images-ihjoz-com.s3.amazonaws.com"],
        fontsize_formats: "10px 12px 14px 16px 18px 24px 36px 48px",
        font_formats: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats;Open Sans=Open Sans, Helvetica, Tahoma, sans-serif"
      },
      editFields: {
        address: false,
        email: false,
        phone_number: false,
        logo: false
      },
      selectedPhoneCountryCode: "961",
      originalStates: {}
    };
  },

  computed: {
    sequenceNumber () {
      if (this.sequenceNumberId) {
        return this.sequenceNumbers.find((number) => number.id == this.sequenceNumberId);
      } else {
        return { id: null, prefix: null, next_number: null };
      }
    },

    currencies () {
      return this.$_.uniq(this.currencyTenants.map(currencyTenant => currencyTenant.currency), "id");
    },

    manualNumbering () {
      return this.voucherTemplate.manual_numbering;
    },

    merchantLabel () {
      if (this.merchant.merchant_type === "Company") {
        return "Legal Name";
      } else {
        return "Full Name";
      }
    },

    editorTypes () {
      return [
        { name: "Simple Invoice (amount only)", value: false },
        { name: "Line Item (default)", value: true }
      ];
    },

    dueDateOptions () {
      return [
        { name: "Due on Receipt", value: "on_receipt" },
        { name: "Net 15", value: "15" },
        { name: "Net 30", value: "30" },
        { name: "Net 45", value: "45" },
        { name: "Net 60", value: "60" },
        { name: "Net 90", value: "90" },
        { name: "Custom", value: "custom" }
      ];
    },

    chevronDirection () {
      if (this.opened) {
        return "icon-chevron-up";
      } else {
        return "icon-chevron-down";
      }
    },

    templateZipCityCountry () {
      let { zip_code: zipCode = "", city: templateCity = "" } = this.voucherTemplate;

      if (zipCode === null) {
        zipCode = "";
      }

      if (templateCity === null) {
        templateCity = "";
      }

      let zipCity = `${zipCode} ${templateCity}`.trim();

      if (this.voucherTemplate.country.name) {
        if (zipCity) {
          return `${zipCity}, ${this.voucherTemplate.country.name}`;
        } else {
          return this.voucherTemplate.country.name;
        }
      } else {
        return zipCity;
      }
    },

    hasMerchantAddress () {
      if (this.merchant.address ||
        this.merchant.zip_code ||
        this.merchant.city ||
        this.merchant.country_id) {
        return true;
      } else {
        return false;
      }
    },

    splitAddress () {
      return this.voucherTemplate.address.split("\r\n");
    },

    submitButtonText () {
      if (this.setupComplete) {
        return "";
      } else {
        return "Create your first invoice";
      }
    }
  },

  watch: {
    "voucherTemplate.manual_numbering": function (newVal, _) {
      this.manualNumbering = newVal;
    }
  },

  created () {
    if (this.voucherTemplate.sequence_number) {
      this.sequenceNumberId = this.voucherTemplate.sequence_number.id;
    }

    this.initializeTemplateMerchantInfo();
  },

  mounted () {
    this.fetchPaymentMethods();
    this.fetchInvoiceFees();
    this.initializeCountryCodes();
    this.initializeOriginalStates();
  },

  methods: {
    initializeTemplateMerchantInfo () {
      this.voucherTemplate.phone_number = this.voucherTemplate.phone_number || this.merchant.phone_number;
      this.voucherTemplate.address = this.voucherTemplate.address || this.merchant.address;
      this.voucherTemplate.zip_code = this.voucherTemplate.zip_code || this.merchant.zip_code;
      this.voucherTemplate.city = this.voucherTemplate.city || this.merchant.city;
      this.voucherTemplate.country_id = this.voucherTemplate.country_id || this.merchant.country_id;
      this.voucherTemplate.country = this.voucherTemplate.country || this.merchant.country;
      this.voucherTemplate.email = this.voucherTemplate.email || this.merchant.email;
      this.voucherTemplate.logo = this.voucherTemplate.logo.url ? this.voucherTemplate.logo : this.merchant.logo;
      this.voucherTemplate.merchant_base_currency = this.voucherTemplate.merchant_base_currency.iso_code ? this.voucherTemplate.merchant_base_currency : this.getBaseCurrency();
    },

    initializeCountryCodes () {
      this.selectedPhoneCountryCode = this.$refs.phoneInput.activeCountry.dialCode;
    },

    initializeOriginalStates () {
      this.originalStates.selectedPhoneCountryCode = this.selectedPhoneCountryCode;
      this.originalStates.phone_number = this.voucherTemplate.phone_number;
      this.originalStates.address = this.voucherTemplate.address;
      this.originalStates.zip_code = this.voucherTemplate.zip_code;
      this.originalStates.city = this.voucherTemplate.city;
      this.originalStates.country_id = this.voucherTemplate.country_id;
      this.originalStates.email = this.voucherTemplate.email;
      this.originalStates.logo = this.voucherTemplate.logo;
    },

    getBaseCurrency () {
      return this.currencies.filter(currency => currency.id === this.merchant.base_currency_id)[0];
    },

    onInput ({ number, isValid, country }) {
      this.selectedPhoneCountryCode = country.dialCode;
    },

    validateNumber (formattedNumber, { number, valid, country }) {
      if (number.input && !valid) {
        document.getElementById("phoneInput").setCustomValidity("Please enter a valid number.");
      } else {
        document.getElementById("phoneInput").setCustomValidity("");
      }
    },

    flipOpened () {
      this.opened = !this.opened;
    },

    displayFees (fee) {
      if (fee) {
        var FeeArray = fee.split("\r\n");
        var currencyFeeHash = {};
        for (var index = 0; index < FeeArray.length; index++) {
          if (FeeArray[index]) {
            var currencyFee = FeeArray[index].split(":");
            currencyFeeHash[currencyFee[0].trim()] = currencyFee[1];
          } else {
            return "-";
          }
        }
        return currencyFeeHash[this.voucherTemplate.merchant_base_currency.iso_code];
      } else {
        return "-";
      }
    },

    editOrAddText (field) {
      if (field) {
        return "Edit";
      } else {
        return "Add";
      }
    },

    toggleEdit (field, resettedItems) {
      this.editFields[field] = !this.editFields[field];

      if (resettedItems) {
        resettedItems.forEach(item => { this.voucherTemplate[item] = this.originalStates[item]; });
      }
    },

    async fetchPaymentMethods () {
      this.paymentMethodsCollection = await PaymentMethodStore.methods.filter(this.merchant.country.id, this.merchant.base_currency_id, Dashboard.currentTenant.id);
      this.paymentMethods = this.paymentMethodsCollection.payment_methods;
    },

    async fetchInvoiceFees () {
      this.invoiceFeesCollection = await TenantStore.methods.fetchFees(Dashboard.currentTenant.id);
      this.selectedInvoiceFee = this.invoiceFeesCollection.filter(fee => (fee.service === "Invoicing" && fee.currency_id === this.merchant.base_currency_id))[0];
    }
  }
};

</script>
